// extracted by mini-css-extract-plugin
module.exports = {"pill":"styles_pill__3tzj4"};